







"use strict";

require("../css/p2p-css.css");

const httpUtil = require("common-util/browser/http-util");
const AppPage = require("common-util/browser/app-page");
const Util = require("./util");
const util = new Util();

class AppPageCommon extends AppPage {
    constructor(params) {
        super(params);
    }

    ready(callback) {
        super.ready(() => {
            
            
            if (!this.session) {
                $("body").children().css("display", "none");
                return;
            }
            callback();
        });
    }
}

const app = new AppPageCommon({
    supportedLang: require("./lang/supported.js"),
    loginCallback() {
        
        this.defaultLoginCallback(data => {
            this.moveToLoginPage(data);
        });
    },
    onLoginError(errorDetail) {
        let self = this;
        util.messageBoxError(errorDetail, () => {
            self.logout(errorDetail);
        });
    },
    onAjaxAuthError(errorDetail) {
        if (errorDetail.status === 401 || errorDetail.status === 403) {
            let self = this;
            util.messageBoxError(errorDetail.responseJSON, () => {
                self.logout(errorDetail);
            });
        } else if (errorDetail.status >= 400) {
            util.messageBoxError(errorDetail.responseJSON);
        } else {
            
            util.messageBoxError("communicationError");
        }
    },
    logoutUrl: httpUtil.getApiUrl("/spfauth/logout")
});

module.exports = app;
